import React from 'react';

function Header () {
  return (
  <header className="masthead d-flex">
  </header>
  )
}

export default Header